import fetchWithAuth from "@/api/secureFetch";
import type { ProductBuildSummary } from "./types";
import type { ProductCreationContext } from "../newProduct/state";

async function readError(response: Response, fallback: string): Promise<Error> {
    const body = await response.json().catch(() => ({}));
    const error = body?.error;
    const message = typeof error === "string"
        ? error
        : typeof error?.message === "string"
          ? error.message
          : fallback;
    return new Error(message);
}

export async function startProductBuild(
    projectId: number,
    sources: Record<string, unknown>,
    token: string,
    creationContext?: ProductCreationContext
): Promise<ProductBuildSummary> {
    const response = await fetchWithAuth(`/api/project/${projectId}/product-build`, token, {
        method: "POST",
        body: JSON.stringify({
            sources,
            ...(creationContext ? { creation_context: creationContext } : {})
        })
    });
    if (!response.ok) throw await readError(response, `Failed to start product build (${response.status})`);
    const body = await response.json();
    return body.build;
}

export async function retryProductBuildActivity(
    projectId: number,
    activityType: string,
    token: string
): Promise<ProductBuildSummary> {
    const response = await fetchWithAuth(`/api/project/${projectId}/product-build/retry`, token, {
        method: "POST",
        body: JSON.stringify({ activity_type: activityType })
    });
    if (!response.ok) throw await readError(response, `Failed to retry product build (${response.status})`);
    const body = await response.json();
    return body.build;
}
